import {CompanyResponse, useGetImage} from '@api'
import {getUserData, onImageError} from '@common'
import {ImageType, TranslationKey} from '@enums'
import {Typography} from '@mui/material'
import {getUserSelectionAtom} from '@state'

import React from 'react'

import {ContractStepper} from 'components/ui-kit'
import {getDefaultStore} from 'jotai'
import {useTranslation} from 'react-i18next'

import {UIKit} from '@components'

import {ContentWrapper, FullContentWrapper, imageStyle, StepperWrapper, TextWrapper} from './style'

interface Props {
  company?: CompanyResponse
  steps: string[]
  activeStep: number
}

/**
 * Contract Header component with Company logo and name and Contract Steps
 */
export function ContractHeader(props: Props) {
  const {company, steps, activeStep} = props

  const currentUser = getUserData()
  const userSelectionMap = getDefaultStore().get(getUserSelectionAtom)
  const userSelection = userSelectionMap[currentUser?.id]

  const {data: image} = useGetImage(ImageType.COMPANY, userSelection?.companyId)
  const {t} = useTranslation()
  return (
    <UIKit.BackgroundCard>
      <FullContentWrapper>
        <ContentWrapper>
          <img style={imageStyle} src={image} onError={onImageError} />
          <TextWrapper>
            <Typography variant="h1">{company?.name ?? t(TranslationKey.Company)}</Typography>
            <Typography>{company?.description}</Typography>
          </TextWrapper>
        </ContentWrapper>
        <StepperWrapper>
          <ContractStepper activeStep={activeStep} steps={steps} />
        </StepperWrapper>
      </FullContentWrapper>
    </UIKit.BackgroundCard>
  )
}
